module.exports = __webpack_public_path__ + "img/upvote.4110f4ed.png";